<template>
  <el-dialog
    :title="title"
    :visible.sync="important_dialogVisible"
    width="70%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item prop="projectName" label="项目名称">
          <el-input
            type="textarea"
            v-model="form.projectName"
            :autosize="{ minRows: 3, maxRows: 5 }"
            show-word-limit
            placeholder="请输入项目名称"
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item prop="projectDescription" label="项目简介">
          <el-input
            type="textarea"
            v-model="form.projectDescription"
            :autosize="{ minRows: 3, maxRows: 5 }"
            show-word-limit
            maxlength="200"
            placeholder="请输入项目简介"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:center;" class="mt30">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { importantSave, importantUpdate,importantView } from "@/api/index";
export default {
  props: {
    important_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      title: "新增",
      form: {
        projectName: "",
        projectDescription: ""
      },
      rules: {
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" }
        ],
        projectDescription: [
          { required: true, message: "请输入项目简介", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    if(this.id){
        this.title = "修改";
      importantView(this.id).then(res=>{
        this.form = res.data
      })
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:important_dialogVisible", false);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.id) {
            //修改
            importantUpdate({
              ...this.form
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
                this.$emit("update:important_dialogVisible");
                this.$emit("refresh");
              }
            });
          } else {
            //新增
            importantSave({
              ...this.form
            }).then(res => {
              if (res.status == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success"
                });
                this.$emit("update:important_dialogVisible");
                this.$emit("refresh");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>